FD.Page = (function ($, me) {
    'use strict';

    me.Page = me.Page || {};

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return me.Page;
}(jQuery, FD));